import React from "react";
import Layout from "../../layouts/Layout";
import { connect } from "react-redux";
import actions from "../../redux/actions";
import { useNavigate } from "react-router-dom";
import BButton from "../../components/general/BButton";
import apiService from '../../utils/api.service';
import helper from "../../utils/helper";
import * as XLSX from "xlsx";
import _ from "lodash"

class WorkShiftScheduleUpload extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      refresh: true,
      excelData: []
    };
    this.createInputxlsx = this.createInputxlsx.bind(this);
    this.onUploadAPI = this.onUploadAPI.bind(this);
    this.reloadRefresh = this.reloadRefresh.bind(this);
  }

  createInputxlsx(e) {
    console.log('files[0] >>', e.target.files[0])
    const f = e.target.files[0]
    var name = f.name;
    console.log("name file >>", name);
    const reader = new FileReader();
    reader.onload = (evt) => {
      const bstr = evt.target.result;
      const wb = XLSX.read(bstr, { type: "binary" });
      const wsname = wb.SheetNames[0]; // เลือกชีส แรก
      const ws = wb.Sheets[wsname];
      const tmp = XLSX.utils.sheet_to_csv(ws, { header: 1 });
      const data0 = this.csvToData(tmp);
      console.log('data0 >>', data0)
      this.setState({ excelData: data0 })
    };
    reader.readAsBinaryString(f);
    // console.log(this.fileinput);
  }

  csvToData(csv = '') {
    var lines = csv.split("\n");
    var result = [];
    var headers;
    headers = lines[0].split(",");

    console.log('headers >>', headers)
    let monthYear = headers[1]
    let dayAllMonthYear = headers.splice(2, headers.length)
    console.log('monthYear >>', monthYear)
    console.log('dayAllMonthYear >>', dayAllMonthYear)
    

    let cutData = []
    let tmp1 = []
    for (var i = 1; i < lines.length; i++) {
      var words = lines[i].split(",");
      // console.log('words >>', words)
      if (words[0] == 'ชื่อโรงพยาบาล') {
        if (tmp1.length > 0) {
          cutData.push(tmp1)
        }
        tmp1 = []
        tmp1.push(words)
      } else {
        tmp1.push(words)
      }

      if (i === lines.length - 1) {
        cutData.push(tmp1)
        tmp1 = []
      }
    }

    console.log('cutData >>', cutData)
    const shiftAllToKey = (shiftAll = []) => {
      let ans = {}
      for (const sa of shiftAll) {
        const [timeRange, shiftCode] = `${sa}`.split(' ')
        ans[shiftCode] = timeRange
      }
      return ans
    }
    const shiftAllToShift = (shiftAll = []) => {
      let ans = []
      for (const sa of shiftAll) {
        console.log('sa >>', sa)
        if (sa) {
          const [timeRange, shiftCode] = `${sa}`.split(' ')
          const [shiftTimeFrom, shiftTimeTo] = `${timeRange}`.split('-')
          const obj = {
            shiftCode: shiftCode,
            shift: helper.FN.shiftToNumber(shiftCode),
            shiftTimeFrom: shiftTimeFrom.replace('.', ':'),
            shiftTimeTo: shiftTimeTo.replace('.', ':'),
          }

          ans.push(obj)
        }
      }
      return ans
    }
    let schedule = []
    for (const cd of cutData) {
      const startMember = cd.findIndex(item => item[0] === '1')
      console.log('startMember>>', startMember)
      const detailData = cd.slice(0,startMember)
      const memberData = cd.slice(startMember,cd.length)
      const shiftAll = detailData.slice(2, detailData.length).map(item => item[1])
      const shift = shiftAllToShift(shiftAll)
      const shiftKeyAll = shiftAllToKey(shiftAll)
      let obj = {
        hospitalName: detailData[0][1],
        wardName: detailData[1][1],
        // shiftAll: shiftAll,
        shift: shift,
        // shiftKeyAll: shiftKeyAll,
        bookingWork: []
      }

      // console.log('detailData >>', detailData)
      console.log('memberData >>', memberData)
      // console.log('obj >>', obj)
      // console.log('-----------------------------------------')
      let memberBook1 = []
      for (const m1 of memberData) {
        const obj1 = {
          memberCode: m1.slice(1,2)[0],
          bookingList: m1.slice(2,m1.length)
        }
        memberBook1.push(obj1)
      }
      console.log('memberBook1 >>', memberBook1)
      let memberBook2 = []
      for (const m2 of memberBook1) {
        for (const i in m2.bookingList) {
          const bkl = m2.bookingList[i]
          const shiftCodeList = bkl.split('/').filter(item => item !== '')
          const obj2 = {
            date: helper.FN.monthTHYearToNumber(monthYear) + '-' +  helper.FN.numberWithZero(Number(i) + 1, 2),
            memberCode: m2.memberCode,
            shift: shiftCodeList.map(item => helper.FN.shiftToNumber(item)).sort(),
            shiftCode: shiftCodeList
          }

          if (obj2.shift.length) { // เอาเฉพาะที่มีกะ
            memberBook2.push(obj2)
          }
        }
       
      }
      // console.log('memberBook2 >>', memberBook2)
      obj.bookingWork = memberBook2
      schedule.push(obj)
    }
    const yearMonth = helper.FN.monthTHYearToNumber(monthYear)
    const [year, month] = yearMonth.split('-') 
    
    const payload = { year, month, schedule }
    return payload;
  }

  csvToJSON(csv) {
    var lines = csv.split("\n");
    var result = [];
    var headers;
    headers = lines[0].split(",");

    for (var i = 1; i < lines.length; i++) {
      var obj = {};

      if (lines[i] == undefined || lines[i].trim() == "") {
        continue;
      }

      var words = lines[i].split(",");
      for (var j = 0; j < words.length; j++) {
        obj[headers[j].trim()] = words[j];
      }

      result.push(obj);
    }
    return result;
  }

  reloadRefresh () {
    this.setState ({ refresh:false }, () => {
      setTimeout(() => this.setState ({ refresh: true }), 200)
    })
  }

  async onUploadAPI() {
    const excelData = this.state.excelData
    const payload = excelData
    console.log('payload >>', payload)
    try {
      this.setState({ loading: true });
      const header = {}
      const { resData } = await apiService.Iframe.CreateImportSchedule(payload, header)
      this.setState({ loading: false });
      if (resData.resultCode === "20000") {
        alert('สำเร็จ')
        this.setState({ excelData: [] }, this.reloadRefresh)
      } else {
        alert('ไม่สำเร็จ' + resData.data)
      }
      this.setState({ loading: false });
    }
    catch(e){
      console.log('API ERR', e)
      alert('มีบางอย่างผิดพลาด')
      this.setState({ loading: false });
    }
  }

  render() {
    return (
      <div>
        <BButton onClick={()=> {window.open(`${apiService.External.BaseFile}/api/excel-work-shift-template`,'_blank')} } setStyle="mini" disable={this.state.loading}>
          ดาวน์โหลด Template
        </BButton>
        <br/>
        <br/>
        { this.state.refresh ? ( <input id="" type="file" onChange={(e) => this.createInputxlsx(e)} /> ) : <div>Clear...</div>}
        <br/>
        <BButton onClick={this.onUploadAPI} setStyle="mini" disable={this.state.loading || this.state.excelData.length === 0}>
          อัพโหลดตารางเวร
        </BButton>
      </div>
    );
  }
}

function WorkShiftScheduleUploadRoute(props) {
  let navigate = useNavigate();
  return <WorkShiftScheduleUpload navigate={navigate} {...props} />;
}

const mapStateToProps = (state) => {
  return {
    ...state,
  };
};
export default connect(mapStateToProps, actions)(WorkShiftScheduleUploadRoute);
